function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.74372 8.95125C6.17262 7.65366 7.00034 6.52466 8.10883 5.72531C9.21731 4.92597 10.5499 4.49711 11.9166 4.49992C13.4657 4.49992 14.8664 5.04992 15.9664 5.95008L19.1674 2.75C17.2167 1.04958 14.717 0 11.9166 0C7.58072 0 3.84806 2.47317 2.05322 6.09583L5.74372 8.95125Z",
  fill: "#EA4335"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6202 16.511C14.621 17.1555 13.3524 17.4992 11.9169 17.4992C10.5557 17.502 9.2281 17.0766 8.12208 16.2831C7.01606 15.4897 6.18765 14.3684 5.75411 13.0781L2.05078 15.8895C2.95942 17.7286 4.36561 19.2761 6.10962 20.356C7.85363 21.436 9.86555 22.0053 11.9169 21.9991C14.6054 21.9991 17.1739 21.043 19.098 19.2491L15.6211 16.511H15.6202Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.0977 19.2502C21.1098 17.3728 22.416 14.5788 22.416 11.0002C22.416 10.3493 22.3161 9.64992 22.1667 9H11.9165V13.2506H17.8162C17.5256 14.6797 16.7437 15.7861 15.6208 16.5121L19.0977 19.2502Z",
  fill: "#4A90E2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.75386 13.0789C5.5296 12.4087 5.41568 11.7066 5.41653 10.9999C5.41653 10.283 5.53111 9.59462 5.74378 8.95112L2.05328 6.0957C1.29829 7.61983 0.909097 9.29901 0.916611 10.9999C0.916611 12.7599 1.32453 14.419 2.05053 15.8903L5.75386 13.0789Z",
  fill: "#FBBC05"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 22,
  fill: "white"
})));

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.98da8e00.svg";
export { ForwardRef as ReactComponent };